// removed by extract-text-webpack-plugin
module.exports = {"ColoredMail":"ColoredMail---3g8v3","HiddenMail":"HiddenMail---243Ca"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/team/styles.styl
// module id = 7TTE
// module chunks = 89